import { RouteActionType } from '../../../context/actions';
import { useRouteContext } from '../../../context/context';

// Hooks act as 'Adapter' layer.
export const useSetNextStopTopScroll = () => {
  const { routeState, routeDispatch } = useRouteContext();

  const setNextStopTopScroll = (topScroll: number) => {
    routeDispatch({
      type: RouteActionType.SET_NEXT_STOP_TOP_SCROLL,
      payload: topScroll,
    });
  };

  return {
    nextStopTopScroll: routeState.nextStopTopScroll,
    setTopScroll: setNextStopTopScroll,
  };
};
